import {
  Box,
  Button,
  FormErrorMessage,
  Heading,
  Input,
  Spinner,
  Textarea,
  useToast,
} from "@chakra-ui/react";
import CardForm from "../../../components/CardForm";
import {
  Setting,
  SetttingGroup,
  useAllGroupSettingsQuery,
  useSaveSettingsMutation,
} from "../../../generated/graphql";
import ResponsiveFormControl from "../../../components/ResponsiveFormControl";
import { Controller, useForm } from "react-hook-form";
import { IFormSetting } from "./interface";
import { useEffect, useState } from "react";
import CardFormTitle from "../../../components/CardForm/CardFormTitle";
import FormImage from "../../../components/FormImage";

const QuotationSetting: React.FC = () => {
  const { data, loading: loadingData } = useAllGroupSettingsQuery({
    variables: {
      group: SetttingGroup.QuotationSetting,
    },
  });

  const {
    register,
    formState: { errors },
    handleSubmit,
    reset,
    control,
  } = useForm<IFormSetting>();

  const [previewSignatureImage, setPreviewSignatureImage] = useState("");

  useEffect(() => {
    const obj: { [key: string]: Setting } = {};

    data?.allGroupSettings.forEach((elm) => {
      obj[elm.key] = elm;
    });

    reset({
      signatureName: obj["signatureName"]?.value,
      signatureImage: obj["signatureImage"]?.value,
      attentions: obj["attentions"]?.value,
    });

    setPreviewSignatureImage(obj["signatureImage"]?.valueImage || "");
  }, [data]);

  const toast = useToast();

  const [saveSettings, { loading }] = useSaveSettingsMutation();

  const onSubmit = async (data: IFormSetting) => {
    try {
      await saveSettings({
        variables: {
          input: {
            group: SetttingGroup.QuotationSetting,
            settings: [
              {
                key: "signatureName",
                value: data.signatureName,
              },
              {
                key: "signatureImage",
                value: data.signatureImage,
              },
              {
                key: "attentions",
                value: data.attentions,
              },
            ],
          },
        },
      });

      toast({ status: "success", description: "Settings saved successfully!" });
    } catch (e) {
    } finally {
    }
  };

  if (loadingData) {
    return <Spinner />;
  }

  return (
    <form onSubmit={handleSubmit(onSubmit)} autoComplete="off">
      <CardForm maxW="container.xl">
        <CardFormTitle>Quotation Settings</CardFormTitle>

        <Heading as="h3" fontSize="lg" mb={4} mt={10}>
          Attention
        </Heading>
        <ResponsiveFormControl
          label="Attentions"
          isRequired
          isInvalid={errors.attentions ? true : false}
          messageComponents={
            <>
              <Box fontSize="sm" color="#555">
                Press Enter to add new line
              </Box>
              <FormErrorMessage>Attentions is required!</FormErrorMessage>
            </>
          }
        >
          <Textarea h="100px" {...register("attentions", { required: true })} />
        </ResponsiveFormControl>
        <Button type="submit" isLoading={loading}>
          Save Settings
        </Button>
      </CardForm>
    </form>
  );
};

export default QuotationSetting;
